
namespace RioERP.Enquiry {
    export class PendingOrdersColumns {
        static columnsKey = 'Enquiry.PendingOrders';
    }
}